function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "11",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.45 5.293L10.046.697a.5.5 0 11.707.707L6.157 6l4.596 4.596a.5.5 0 01-.707.707L5.45 6.707.854 11.303a.5.5 0 11-.708-.707L4.743 6 .146 1.404A.5.5 0 11.854.697L5.45 5.293z",
  fill: "#54585D",
  fillRule: "nonzero"
})));